import ListCreditScoreGeographicallyBox from './ListCreditScoreGeographicallyBox'

export default ListCreditScoreGeographicallyBox
